























































import { defineComponent, ref, watch } from '@vue/composition-api'
import { useStore } from '@/store'

export default defineComponent({
  name: 'MAS',

  props: {
    next: String
  },

  setup() {
    const { state, stopRoute } = useStore()

    const step = ref(1)

    watch(step, () => {
      const content = document.querySelector('.c-popover--open')
      if (content) {
        content.scrollTop = 0
      }
    })

    return {
      state,
      step,
      stopRoute
    }
  }
})
